import type { IInfluencer } from '../redux/buzzbridge/types';
import { stripLeadingAt } from '../utils/socialHandle';

export function normalizePublicProfileUserName(userName: string): string {
    return stripLeadingAt(userName);
}

/** Unwrap GET /influencers/public/:userName — supports { data: { influencer } } envelopes. */
export function parsePublicInfluencerProfileResponse(response: unknown): IInfluencer {
    const root = response as { data?: { influencer?: IInfluencer; data?: { influencer?: IInfluencer } } } | null;
    const influencer = root?.data?.influencer ?? root?.data?.data?.influencer;
    if (!influencer || typeof influencer !== 'object') {
        throw new Error('Profile not available');
    }
    return influencer;
}
